import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { AnonymousGuard } from './core/guards/anonymous.guard';
import { AuthGuard } from './core/guards/auth.guard';
import { DeliveryLayoutComponent } from './core/layouts/delivery-layout/delivery-layout.component';
import { FullLayoutComponent } from './core/layouts/full-layout/full-layout.component';
import { MainLayoutComponent } from './core/layouts/main-layout/main-layout.component';
import { OfflineGuard } from './core/guards/offline.guard';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        // canActivate: [],
        redirectTo: '/inbox/current',
        pathMatch: 'full',
      },
      {
        path: 'offline',
        loadChildren: () => import('./offline/offline.module').then((m) => m.OfflineModule),
      },
      {
        path: 'inbox',
        loadChildren: () => import('./inbox/inbox.module').then((m) => m.InboxModule),
        canActivate: [OfflineGuard],
      },
      {
        path: 'search',
        loadChildren: () => import('./inbox/inbox.module').then((m) => m.InboxModule),
      },
      {
        path: 'account-settings',
        loadChildren: () =>
          import('./settings/account-settings/account-settings.module').then(
            (mod) => mod.AccountSettingsModule,
          ),
        canActivate: [OfflineGuard],
      },
      {
        path: 'settings',
        loadChildren: () => import('./settings/settings.module').then((m) => m.SettingsModule),
      },
    ],
  },
  // {
  //   path: '',
  //   canActivate: [AnonymousGuard],
  //   component: DeliveryLockLayoutComponent,
  //   children: [
  //     {
  //       path: 'delivery/lock/:id',
  //       loadChildren: () =>
  //         import('./delivery/lock-screen/lock-screen.module').then((m) => m.LockScreenModule),
  //     },
  //   ],
  // },
  {
    path: '',
    component: FullLayoutComponent,
    children: [
      {
        path: 'delivery-lock-share',
        loadChildren: () =>
          import('./delivery/lock-share/lock-share.module').then((m) => m.LockShareModule),
        canActivate: [],
      },
      {
        path: 'auth',
        loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
      },
    ],
  },
  {
    path: '',
    canActivate: [AuthGuard],
    component: DeliveryLayoutComponent,
    children: [
      {
        path: 'delivery',
        loadChildren: () => import('./delivery/delivery.module').then((m) => m.DeliveryModule),
      },
    ],
  },
  {
    path: '',
    redirectTo: '/inbox/current',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '/',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule],
  providers: [AnonymousGuard]
})
export class AppRoutingModule { }
